<template src="./unitSummaryComponent.template.html"></template>

<script>
    import moment from "moment-timezone";
    import accounting from "accounting";
    
    export default {
        name: "unitSummaryComponent",
        props: ['openUnitSummaryPanel', 'closeUnitSummaryPanel', 'unitSummaryObj', 'unitSummaryPanelCallBack'],

        data() {
            return {
                apiUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : ''),
                unitDataObj: {},
                beList: [],
                imageUrlsList: []
            };
        },
        methods: {
            getUnitDetailById() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                key: "GetUnitDetailById",
                params: {
                    ModuleAction: "GetUnitDetailById",
                    UnitId: vm.unitSummaryObj.IsAssigned != 0 ? vm.unitSummaryObj.UnitId : vm.unitSummaryObj.UnitTypeId,
                    PropertyId: vm.unitSummaryObj.PropertyId
                },
                callback: function (err, response) {
                    console.log("GetUnitDetailById response ==>", response);
                    if (response) {
                        vm.unitDataObj = response.UnitDataObj[0];
                        vm.imageUrlsList = response.ImgUrls
                        // vm.unitData.Description = vm.unitData.Description ? vm.unitData.Description.replace(/\n/g, '<br>') : vm.unitData.Description;
                        let propertyDetail = response.propertyDetail;
                        let unitPropertyAddress = [];
                        let address = propertyDetail.Address1;
                        let cityName = propertyDetail.cityName;
                        let stateName = propertyDetail.stateName;
                        if (address != undefined && address != "") {
                            unitPropertyAddress.push(address);
                        }
                        if (cityName != undefined && cityName != "") {
                            unitPropertyAddress.push(cityName);
                        }
                        if (stateName != undefined && stateName != "") {
                            unitPropertyAddress.push(stateName);
                        }
                        vm.unitDataObj.Address = unitPropertyAddress.join(", ").toString();
                    } else {
                    console.log(err);
                    }
                }
                });
            },
            formatAmount(amount) {
                let currency = accounting.formatMoney(amount, {
                    symbol: "$",
                    format: {
                    pos: "%s %v",
                    neg: "%s (%v)",
                    zero: "%s  %v",
                    },
                    thousand: ",",
                    precision: 0,
                    decimal: ".",
                });
                return currency;
            }, 
            text_truncate(str, length, ending) {
                if (str && str.length) {
                    str = str.replaceAll("<br>", " ");
                    if (length == null) {
                        length = 110;
                    }
                    if (ending == null) {
                        ending = '...';
                    }
                    if (str.length > length) {
                        return str.substring(0, length - ending.length);
                    } else {
                        return str;
                    }
                }
            },
            navigateToUnitDetailPageBE(inst) {
                let vm = this;
                // vm.$router.push("/unitDetail" + "/" + vm.unitSummaryObj.UnitId + "/" + vm.unitSummaryObj.PropertyId)
                let selectedUnitId = vm.unitSummaryObj.IsAssigned != 0 ? vm.unitSummaryObj.UnitId : vm.unitSummaryObj.UnitTypeId
                let activeDomainName = vm.beList[0].SubDomainName+'.'+vm.beList[0].TLD_Name;
                var unitDetailPageUrl = window.location.protocol + '//' + activeDomainName + '/#/unitDetail/' + selectedUnitId + '/' + vm.unitSummaryObj.PropertyId;
                if (vm.unitSummaryObj.startDate && vm.unitSummaryObj.endDate) {
                    // unitDetailPageUrl = window.location.protocol + '//' + 'test-be.localhost:8080' + '/#/unitDetail/' 
                    // + vm.unitSummaryObj.UnitId + '/' + vm.unitSummaryObj.PropertyId + '?' 
                    // + 'UnitId=' + vm.unitSummaryObj.UnitId + '&PropertyId=' + vm.unitSummaryObj.PropertyId 
                    // + '&CheckIn=' + vm.unitSummaryObj.startDate + '&CheckOut=' + vm.unitSummaryObj.endDate 
                    // + '&Persons=' + vm.unitSummaryObj.Persons + '&RatePlanId=' + vm.unitSummaryObj.RatePlanId;

                    unitDetailPageUrl = window.location.protocol + '//' + activeDomainName + '/#/unitDetail/' 
                    + selectedUnitId + '/' + vm.unitSummaryObj.PropertyId + '?' 
                    + 'UnitId=' + selectedUnitId + '&PropertyId=' + vm.unitSummaryObj.PropertyId 
                    + '&CheckIn=' + vm.unitSummaryObj.startDate + '&CheckOut=' + vm.unitSummaryObj.endDate 
                    + '&Persons=' + vm.unitSummaryObj.Persons + '&RatePlanId=' + vm.unitSummaryObj.RatePlanId;                   
                } else {
                    // unitDetailPageUrl = window.location.protocol + '//' + 'test-be.localhost:8080' + '/#/unitDetail/' + vm.unitSummaryObj.UnitId + '/' + vm.unitSummaryObj.PropertyId;

                    unitDetailPageUrl = window.location.protocol + '//' + activeDomainName + '/#/unitDetail/' + selectedUnitId + '/' + vm.unitSummaryObj.PropertyId;
                }
                
                let newTab = window.open(unitDetailPageUrl,'_blank');
                newTab.location.reload(true); // true indicates a hard reload
            },
            navigateToUnitSetupPage() {
                let vm = this;
                // vm.$router.push("/unitDetail/" + vm.unitSummaryObj.UnitId + "/" + vm.unitSummaryObj.PropertyId);
                let selectedUnitId = vm.unitSummaryObj.IsAssigned != 0 ? vm.unitSummaryObj.UnitId : vm.unitSummaryObj.UnitTypeId
                let redirectPageName = vm.unitSummaryObj.IsAssigned != 0 ? 'unitDetail':'unitTypeDetail'
                let port = window.location.port ? (':'+window.location.port) : '';
                let unitSetupUrl = window.location.protocol + '//' + window.location.hostname + port + '/#/'+redirectPageName+'/' + selectedUnitId + '/' + vm.unitSummaryObj.PropertyId;
                window.open(unitSetupUrl)
            },
            imageUrls(imgGuid) {
                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid);
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + "/downloadImage/" + imgGuid + "/430x300";
            },
            closeUnitPanel() {
                var vm = this;
                vm.closeUnitSummaryPanel(false);
            },
            getBESubDomain() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                key: "getBE_List",
                params: {
                    ModuleAction: "getBE_List",
                    IsActive: 1,
                    UnitId: vm.unitSummaryObj.UnitId
                },
                callback: function (err, response) {
                    console.log("getBE_List response ==>", response);
                    if (response) {
                        vm.beList = response[0];
                    } else {
                    console.log(err);
                    }
                }
                });
            }
        },
        computed: {
           
        },
        watch: {
            // openUnitSummaryPanel(oldValue, newValue) {
            //     let vm = this;
            //     if (oldValue) {
            //         vm.getUnitDetailById();
            //     }
            // }
        },
        mounted() {
            let vm = this;            
            // $(document).click(function (e) {
            //     console.log("clicked on doc");                
            // })
            vm.getUnitDetailById();
            vm.getBESubDomain();
        },
        components: {

        },
    };

</script>